import React from 'react'

function StockManagement() {
  return (
    <div>Stock Management (inward/outward/expiry alert)</div>
  )
}

export default StockManagement